export const role_list = [
  { name: "ทั่วไป", value: "PUBLIC" },
  { name: "ประชาชนทั่วไป", value: "PATIENT" },
  { name: "แพทย์/เภสัช", value: "MEDICAL_PERSONNEL" },
  { name: "ผู้ดูแลห้องปฏิบัติการ", value: "LABORATORY_ADMIN" },
  { name: "ผู้ปฏิบัติการในห้องปฏิบัติการ", value: "LABORATORY_PERSONNEL" },
  { name: "เจ้าหน้าที่โรงพยาบาล", value: "HOSPITAL_PERSONNEL" },
  { name: "ผู้บริหาร", value: "EXECUTIVE" },
  { name: "โรงพยาบาล", value: "HOSPITAL" },
  { name: "ผู้ดูแลระบบ", value: "ADMIN" },
];
